import { render, staticRenderFns } from "./restaurantLogin.vue?vue&type=template&id=6fc22a70&scoped=true&"
import script from "./restaurantLogin.vue?vue&type=script&lang=js&"
export * from "./restaurantLogin.vue?vue&type=script&lang=js&"
import style0 from "./restaurantLogin.vue?vue&type=style&index=0&id=6fc22a70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc22a70",
  null
  
)

export default component.exports